import styled from "styled-components";

export const CommentList = styled.ul`
  gap: 12px;
  display: flex;
  padding: 16px 16px 96px;
  overflow-y: auto;
  min-height: calc(100vh - 126px);
  align-items: center;
  flex-direction: column;
`;
